module.exports = __webpack_public_path__ + "media/images/new_landing/hp/tile-8-7660cf6218ca2bf08407c63ad2830e0d.jpg";